<!--
  detailsModal: reusable centered dialog shell (overlay, title bar with optional Back/Close, body slot).
  Used by detailsModalHost to show inner screens (controls, KPIs, compliance, objectives, etc.) as dialogs.
-->
<template>
	<div v-if="modelValue" class="details-modal-overlay" @click.self="onClose">
		<div class="details-modal">
			<div class="details-modal-bar">
				<button
					v-if="showBack"
					class="btnprimary"
					@click="$emit('back')"
				>Back</button>
				<div class="details-modal-heading" :title="title">
					{{ title }}
				</div>
				<button class="float-right text-3xl" @click="onClose">
					<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
				</button>
			</div>
			<div class="details-modal-body">
				<slot />
			</div>
		</div>
	</div>
</template>
<style scoped>
.details-modal-overlay {
	position: fixed;
	inset: 0;
	z-index: 9000;
	background: rgba(0, 0, 0, 0.4);
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 24px;
}
.details-modal {
	width: 85vw;
	height: 80vh;
	max-height: 80%;
	background: #ffffff;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	border-radius: 4px;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}
.details-modal-bar {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
	padding: 12px 16px;
	border-bottom: 1px solid var(--color-lightgrey);
	flex-shrink: 0;
}
.details-modal-heading {
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14px;
	font-weight: 600;
	color: #000;
}
.details-modal-body {
	flex: 1;
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.details-modal-body > * {
	flex: 1;
	min-height: 0;
	height: 100%;
	overflow: auto;
}
.details-modal-body :deep(.task-details-in-modal) {
	overflow: hidden !important;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'detailsModal',
	props: {
		modelValue: { type: Boolean, default: false },
		title: { type: String, default: '' },
		showBack: { type: Boolean, default: false },
	},
	emits: ['update:modelValue', 'close', 'back'],
	methods: {
		onClose() {
			this.$emit('update:modelValue', false);
			this.$emit('close');
		},
	},
});
</script>
